import {
	Glob, 
	IGlob 
} from "../glob";

export const SecurityActionEffects = {
	Allow: "Allow" as const,
	Deny: "Deny" as const
};

export type SecurityActionEffect = typeof SecurityActionEffects[keyof typeof SecurityActionEffects]

export interface ISecurityAction {
	Effect: SecurityActionEffect;
	Path: string;
}

export class ActionAdapter
{
	private readonly $action: ISecurityAction;
	private readonly $glob: IGlob;

	constructor(action: ISecurityAction) {
		this.$action = action;
		this.$glob = new Glob(action.Path);
	}

	get path(): string {
		return this.$action.Path;
	}

	get glob(): IGlob {
		return this.$glob;
	}

	get effect(): SecurityActionEffect {
		return this.$action.Effect;
	}

	isMatch = (path: string) => this.glob.isMatch(path);

	isCongruent = (pathOrGlob: string | IGlob) => {
		return this.glob.isCongruent(pathOrGlob);
	};
}
